<app-header [progress]="2" [title]="locale.currentTranslation.accidentDescriptionHeader" data-testid="accident-location-header"></app-header>
<div class="base-content-container" data-testid="accident-location-container">
  <div class="headline3" data-testid="accident-location-title">{{ locale.currentTranslation.accidentLocation1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;">
    <div class="headline3">{{ locale.currentTranslation.accidentLocation2 }}</div>
    <div>
      <div style="width: 100%;">
        <app-text-input
          [(value)]="street"
          [placeholder]="locale.currentTranslation.accidentLocationPlaceholder1"
          [required]="true"
          [showError]="showError"
          data-testid="input-street"
          [attr.aria-label]="locale.currentTranslation.accidentLocationPlaceholder1"
        ></app-text-input>
      </div>
    </div>
    <div>
      <div style="width: 100%;">
        <app-text-input
          [(value)]="houseNumber"
          [placeholder]="locale.currentTranslation.accidentLocationPlaceholder2"
          [required]="true"
          [showError]="showError"
          data-testid="input-house-number"
          [attr.aria-label]="locale.currentTranslation.accidentLocationPlaceholder2"
        ></app-text-input>
      </div>
    </div>
    <div>
      <div style="width: 100%;">
        <app-text-input
          [(value)]="postcode"
          [type]="'number'"
          [placeholder]="locale.currentTranslation.accidentLocationPlaceholder3"
          [required]="true"
          [showError]="showError"
          data-testid="input-postcode"
          [attr.aria-label]="locale.currentTranslation.accidentLocationPlaceholder3"
        ></app-text-input>
      </div>
    </div>
    <div>
      <div style="width: 100%;">
        <app-text-input
          [(value)]="city"
          [placeholder]="locale.currentTranslation.accidentLocationPlaceholder4"
          [required]="true"
          [showError]="showError"
          data-testid="input-city"
          [attr.aria-label]="locale.currentTranslation.accidentLocationPlaceholder4"
        ></app-text-input>
      </div>
    </div>
    <div class="headline3">{{ locale.currentTranslation.accidentLocation3 }}</div>
    <div>
      <div style="width: 100%;">
        <app-text-input
          [(value)]="date"
          [placeholder]="locale.currentTranslation.accidentLocationPlaceholder5"
          [required]="true"
          [showError]="showError"
          [type]="'date'"
          data-testid="input-date"
          [attr.aria-label]="locale.currentTranslation.accidentLocationPlaceholder5"
        ></app-text-input>
      </div>
    </div>
    <div>
      <div style="width: 100%;">
        <app-text-input
          [(value)]="time"
          [placeholder]="locale.currentTranslation.accidentLocationPlaceholder6"
          [required]="true"
          [showError]="showError"
          [type]="'time'"
          data-testid="input-time"
          [attr.aria-label]="locale.currentTranslation.accidentLocationPlaceholder6"
        ></app-text-input>
      </div>
    </div>
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button (click)="nextClicked()" class="main-button" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="accident-location-footer"></app-footer>
